// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6776) return "static/chunks/6776.b6060724b21a5ae0.js";
	if (chunkId === 2908) return "static/chunks/2908.93bce45f53a3b641.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1818":"5dc11092cfa29d60","6689":"252dbadc02ba6f55","7771":"782574e2dec0ddb9","9975":"9bcc8ba0afc66c08"}[chunkId] + ".js";
};